// Per-facility integration config.
//
// NON-SECRET VALUES ONLY — this module ships in the browser bundle. Credentials
// live in Secrets Manager and are resolved server-side in a later phase;
// `secretRef` below is a name, not a secret.
//
// Keyed by the facility UUIDs already used in src/utils/facilities.ts. It stays
// in code (rather than on the Facility model) for now because src/context/users.tsx
// force-logs-out any admin whose facility fails its shape check, so widening
// that model has a ripple worth taking separately.

import type { PmsFacilityConfig, SsmFacilityConfig } from './types';

/** src/utils/facilities.ts — richmond */
export const RICHMOND_FACILITY_ID = 'd0e84c17-dd2d-448c-9ec3-489f75ba5ce3';
/** src/utils/facilities.ts — tacoma */
const TACOMA_FACILITY_ID = '00abb9ac-79ee-45db-bbcf-568367b56327';

/**
 * 'check' rather than 'cash' so every posted payment carries the Stripe
 * reference: SSM's cashInput is `{ Amount }` and nothing else, which would
 * leave the facility's books with no trace of where the money came from.
 * Pending the facility bookkeeper's preference (plan question 8).
 */
const RICHMOND_SSM: SsmFacilityConfig = {
  // TODO(albert): replace with the facility's real SSM FacilityId before going live.
  facilityId: 0,
  countryId: 1, // US
  paymentMethod: 'check',
  checkBankName: 'Stripe (Bins Valet)',
  adSource: 'Bins Valet',
  mediumDesc: 'bins-storage.com',
  inquirySource: 151, // Internet
  insuranceId: null, // no coverage selected
  postFeesToSsm: false,
  dailyTransactionBudget: 200,
};

const PMS_CONFIG: Record<string, PmsFacilityConfig> = {
  [RICHMOND_FACILITY_ID]: {
    facilityID: RICHMOND_FACILITY_ID,
    provider: 'ssm',
    mode: 'shadow',
    secretRef: 'bins/pms/ssm/richmond',
    ssm: RICHMOND_SSM,
  },
  [TACOMA_FACILITY_ID]: {
    facilityID: TACOMA_FACILITY_ID,
    provider: 'none',
    mode: 'shadow',
  },
};

/**
 * Unknown facility -> provider 'none', which makes every enqueue a no-op. A
 * missing config must never mean "guess"; it means "do nothing".
 */
export function getPmsConfig(facilityID: string | null | undefined): PmsFacilityConfig {
  const id = (facilityID || '').trim();
  const found = id ? PMS_CONFIG[id] : undefined;
  if (found) return found;
  return { facilityID: id, provider: 'none', mode: 'shadow' };
}

export function isShadow(config: PmsFacilityConfig): boolean {
  return config.mode !== 'live';
}
